<template>
  <div class="footer">
<!--   	<h5 class="power">
  		Powered By : <img class="footer-img" src="../assets/images/logo-indocyber.png">
  	</h5>
    <h5>
    	Copyright &copy; {{year}} by PT Inti Sinergi Teknologi
    </h5> -->
  </div>
</template>
<script>
export default {
  name: 'TheFooter',
  data(){
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>
